/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useContext } from 'react';
import ReactCodeInput from "react-code-input";

import { DataContext } from 'providers/data';

import { Box, Typography, Button } from '@mui/material';
import { ButtonRectangle, ButtonOutlined } from 'components/views/form/Button';

import { ContentReactCode } from 'components/views/ContentForgot/styles';

const ValidateToken = ({ pushProgressStep }: { pushProgressStep: (step: number) => void }) => {
    const [pinCode, setPinCode] = useState("");
    const [pinCodeOld, setPinCodeOld] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isPinCodeValid, setIsPinCodeValid] = useState(true);
    const [accountantTime, setAccountantTime] = useState(120);
    const [enableResendToken, setEnableResendToken] = useState(false);

    const { dataSearchPersonData, dataFormPersonal, dataUpdatePersonalData, dataResendToken, handlePutUpdatePersonalData, handlePostResendToken } = useContext(DataContext);

    const handleSendToken = () => {
        const tokenExternal = localStorage.getItem('token_external');
        if (dataSearchPersonData && dataFormPersonal && tokenExternal) {
            setPinCodeOld(pinCode);
            handlePutUpdatePersonalData({ body: dataFormPersonal, token: tokenExternal, tokenSent: pinCode });
        }
    }

    const handleResendToken = () => {
        const tokenExternal = localStorage.getItem('token_external');

        if (tokenExternal && dataFormPersonal) {
            setIsLoading(true);
            handlePostResendToken({ body: dataFormPersonal, token: tokenExternal });
            setPinCode('');
            setAccountantTime(120);
            setEnableResendToken(false);
        }
    }

    const formatTime = (totalSeconds: number) => {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;

        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(seconds).padStart(2, '0');

        return `${formattedMinutes} min : ${formattedSeconds}s`;
    };

    useEffect(() => {
        if (accountantTime > 0 && !enableResendToken) {
            const timer = setInterval(() => {
                setAccountantTime((prev) => prev - 1);
            }, 1000);

            return () => clearInterval(timer);
        } else if (accountantTime === 0) {
            setEnableResendToken(true);
        }
    }, [accountantTime, enableResendToken]);

    useEffect(() => {
        if (pinCodeOld && dataUpdatePersonalData === false && pinCodeOld === pinCode) {
            setIsPinCodeValid(false);
            setIsLoading(false);
            return;
        }

        setIsPinCodeValid(true);
    }, [dataUpdatePersonalData, pinCode, pinCodeOld]);

    useEffect(() => {
        if (typeof dataUpdatePersonalData !== 'undefined') {
            setIsLoading(false);

            if (dataUpdatePersonalData) {
                pushProgressStep(3);
            }
        }

    }, [dataUpdatePersonalData]);

    useEffect(() => {
        if (typeof dataResendToken !== 'undefined') {
            setIsLoading(false);
        }

    }, [dataResendToken]);

    return (
        <Box sx={{
            textAlign: 'center',
            borderRadius: '10px',
            padding: { xs: '1.81rem 0 0', md: '3rem 2.65rem' },
            border: {
                xs: 'none',
                md: '1.5px solid rgba(12, 28, 51, 0.5)'
            }
        }}>
            <Typography fontSize='1.25rem' fontWeight={700} lineHeight='1.81' color='secondary.main' textTransform='uppercase'>
                Token enviado!
            </Typography>

            <Typography fontSize='.9375rem' lineHeight='1' sx={{
                paddingBottom: { xs: '2.75rem', md: '2rem' }
            }}>
                <b>Insira</b> abaixo o Token recebido, para a <b>validação:</b>
            </Typography>

            <ContentReactCode invalidPin={!isPinCodeValid ? 'error' : 'success'}>
                <Typography variant="body2" color='error.main' textAlign='left' sx={{ height: '20px' }}>
                    {!isPinCodeValid && 'Código inválido, por favor tente novamente.'}
                </Typography>
                <ReactCodeInput
                    type='number'
                    fields={6}
                    name="pinCode"
                    inputMode="tel"
                    onChange={(e) => setPinCode(e)}
                    value={pinCode}
                    inputStyle={{
                        width: '3.125rem',
                        height: '3.125rem',
                        borderRadius: '5px',
                        fontSize: '1.875rem',
                        textAlign: 'center',
                        paddingTop: '5px'
                    }}
                />

                <Box sx={{
                    height: '1rem',
                    marginTop: { xs: '.875rem', md: '1.2rem' }
                }}>
                    {enableResendToken ?
                        <Button variant='text' sx={{
                            padding: 0,
                            fontWeight: 700,
                            fontSize: '.9375rem',
                            color: "primary.light",
                            textTransform: 'initial',
                            textDecoration: 'underline',
                        }}
                            onClick={() => handleResendToken()}
                            disabled={isLoading}
                        >
                            Reenviar o token
                        </Button>
                        :
                        <Typography fontSize='.9375rem' color='#ABAEAE' sx={{
                            'span': {
                                color: 'primary.main',
                                fontWeight: 700
                            }
                        }}>
                            Reenvio do token em <span>{formatTime(accountantTime)}</span>
                        </Typography>
                    }
                </Box>
            </ContentReactCode>

            <Box display='grid' rowGap='1rem' sx={{
                marginTop: { xs: '-.925rem', md: '-.5rem' }
            }}>
                <ButtonRectangle
                    name='VALIDAR CÓDIGO'
                    disabled={isPinCodeValid && /[0-9]{6}/.test(pinCode) ? false : true}
                    loadingBtn={isLoading}
                    onClick={() => { setIsLoading(true); handleSendToken() }}
                />
                <ButtonOutlined name="EDITAR INFORMAÇÕES" disabled={isLoading} onClick={() => pushProgressStep(0)} />
            </Box>
        </Box>
    );
}

export default ValidateToken;